'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
/* eslint no-template-curly-in-string: 0 */


var _hash = require('@emotion/hash');

var _hash2 = _interopRequireDefault(_hash);

var _stylis = require('@emotion/stylis');

var _stylis2 = _interopRequireDefault(_stylis);

var _stylisRuleSheet = require('stylis-rule-sheet');

var _stylisRuleSheet2 = _interopRequireDefault(_stylisRuleSheet);

var _utils = require('./utils');

var _sheet = require('./sheet');

var _sheet2 = _interopRequireDefault(_sheet);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // this should probably be an actual type but it's hard to do without errors
// | string
// | number
// | void
// | boolean
// | null
// | Object
// | Array<Interpolation>
// | (() => Interpolation)
// | ((props?: Object, context?: Object) => Interpolation)


function createEmotion(context, options) {
  if (context.__SECRET_FANCY_EMOTION__ !== undefined) {
    return context.__SECRET_FANCY_EMOTION__;
  }

  if (options === undefined) options = {};
  var key = options.key || 'css';

  if (process.env.NODE_ENV !== 'production') {
    if (/[^a-z-]/.test(key)) {
      throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + key + '" was passed');
    }
  }

  var current = void 0;

  function insertRule(rule) {
    current += rule;

    if (_utils.isBrowser) {
      sheet.insert(rule, currentSourceMap);
    }
  }

  var insertionPlugin = (0, _stylisRuleSheet2.default)(insertRule);
  var stylisOptions = void 0;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var caches = {
    registered: {},
    inserted: {},
    nonce: options.nonce,
    key: key
  };
  var sheet = new _sheet2.default(options);

  if (_utils.isBrowser) {
    // 🚀
    sheet.inject();
  }

  var stylis = new _stylis2.default(stylisOptions);
  stylis.use(options.stylisPlugins)(insertionPlugin);
  var currentSourceMap = '';

  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    switch (typeof interpolation === 'undefined' ? 'undefined' : _typeof(interpolation)) {
      case 'boolean':
        return '';

      case 'function':
        if (interpolation.__emotion_styles !== undefined) {
          var selector = interpolation.toString();

          if (selector === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          return selector;
        }

        if (this === undefined && process.env.NODE_ENV !== 'production') {
          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

      case 'object':
        return createStringFromObject.call(this, interpolation);

      default:
        var cached = caches.registered[interpolation];
        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
    }
  }

  var objectToStringCache = new WeakMap();

  function createStringFromObject(obj) {
    if (objectToStringCache.has(obj)) {
      // $FlowFixMe
      return objectToStringCache.get(obj);
    }

    var string = '';

    if (Array.isArray(obj)) {
      obj.forEach(function (interpolation) {
        string += handleInterpolation.call(this, interpolation, false);
      }, this);
    } else {
      Object.keys(obj).forEach(function (key) {
        if (_typeof(obj[key]) !== 'object') {
          if (caches.registered[obj[key]] !== undefined) {
            string += key + '{' + caches.registered[obj[key]] + '}';
          } else {
            string += (0, _utils.processStyleName)(key) + ':' + (0, _utils.processStyleValue)(key, obj[key]) + ';';
          }
        } else {
          if (key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
            obj[key].forEach(function (value) {
              string += (0, _utils.processStyleName)(key) + ':' + (0, _utils.processStyleValue)(key, value) + ';';
            });
          } else {
            string += key + '{' + handleInterpolation.call(this, obj[key], false) + '}';
          }
        }
      }, this);
    }

    objectToStringCache.set(obj, string);
    return string;
  }

  var name = void 0;
  var stylesWithLabel = void 0;
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

  var createStyles = function createStyles(strings) {
    var stringMode = true;
    var styles = '';
    var identifierName = '';

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation.call(this, strings, false);
    } else {
      styles += strings[0];
    }

    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    interpolations.forEach(function (interpolation, i) {
      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
      );

      if (stringMode === true && strings[i + 1] !== undefined) {
        styles += strings[i + 1];
      }
    }, this);
    stylesWithLabel = styles;
    styles = styles.replace(labelPattern, function (match, p1) {
      identifierName += '-' + p1;
      return '';
    });
    name = (0, _hash2.default)(styles + identifierName) + identifierName;
    return styles;
  };

  if (process.env.NODE_ENV !== 'production') {
    var sourceMapRegEx = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
    var oldStylis = stylis;

    stylis = function stylis(selector, styles) {
      var result = sourceMapRegEx.exec(styles);
      currentSourceMap = result ? result[0] : '';
      oldStylis(selector, styles);
      currentSourceMap = '';
    };
  }

  function insert(scope, styles) {
    var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : name;

    if (caches.inserted[namespace] === undefined) {
      current = '';
      stylis(scope, styles);
      caches.inserted[namespace] = current;
    }
  }

  var css = function css() {
    var styles = createStyles.apply(this, arguments);
    var selector = key + '-' + name;

    if (caches.registered[selector] === undefined) {
      caches.registered[selector] = stylesWithLabel;
    }

    insert('.' + selector, styles);
    return selector;
  };
  /**
   * Custom function to generate a CSS rule prefixed with a scope
   * selector. This function enhances the default emotion.css() function.
   *
   * @param  {string} scope
   * @return {function}
   */


  var keyframes = function keyframes() {
    var styles = createStyles.apply(this, arguments);
    var animation = 'animation-' + name;
    insert('', '@keyframes ' + animation + '{' + styles + '}');
    return animation;
  };

  function getRegisteredStyles(registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (caches.registered[className] !== undefined) {
        registeredStyles.push(className);
      } else {
        rawClassName += className + ' ';
      }
    });
    return rawClassName;
  }

  function merge(className, sourceMap) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles, sourceMap);
  }

  function hydrateSingleId(id) {
    caches.inserted[id] = true;
  }

  if (_utils.isBrowser) {
    var chunks = document.querySelectorAll('[data-emotion-' + key + ']');
    Array.prototype.forEach.call(chunks, function (node) {
      // $FlowFixMe
      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

      node.getAttribute('data-emotion-' + key).split(' ').forEach(hydrateSingleId);
    });
  }

  var emotion = {
    flush: function flush() {
      if (_utils.isBrowser) {
        sheet.flush();
        sheet.inject();
      }

      caches.inserted = {};
      caches.registered = {};
    },
    hydrate: function hydrate(ids) {
      ids.forEach(hydrateSingleId);
    },
    cx: function cx() {
      for (var _len2 = arguments.length, classNames = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        classNames[_key2] = arguments[_key2];
      }

      return merge((0, _utils.classnames)(classNames));
    },
    merge: merge,
    getRegisteredStyles: getRegisteredStyles,
    injectGlobal: function injectGlobal() {
      var styles = createStyles.apply(this, arguments);
      insert('', styles);
    },
    keyframes: keyframes,
    css: css,
    cssWithScope: function cssWithScope() {
      var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return function () {
        var styles = createStyles.apply(this, arguments);
        var selector = key + '-' + name;
        var namespace = scope ? scope.replace(/ /g, '-') + '-' + selector : selector;

        if (caches.registered[selector] === undefined) {
          caches.registered[selector] = stylesWithLabel;
        }

        var scopeSelector = scope ? scope.concat(' ') : '';
        insert(scopeSelector + '.' + selector, styles, namespace);
        return selector;
      };
    },
    sheet: sheet,
    caches: caches
  };
  context.__SECRET_FANCY_EMOTION__ = emotion;
  return emotion;
}

exports.default = createEmotion;